// import route file
import { useEffect } from "react";
import AppRoutes from "./routes/Index";

const App = () => {
    useEffect(() => {
        const hasReloaded = sessionStorage.getItem("hasHardReloaded");
      
        if (!hasReloaded) {
          // Set the flag so it doesn't reload again
          sessionStorage.setItem("hasHardReloaded", "true");
      
          // Force a "hard reload" by changing the URL with a random query string
          window.location.href = window.location.pathname + '?hardReload=' + Date.now();
        }
      }, []);

    return (
        <>
            <AppRoutes />
        </>
    );
}

export default App;